// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Vazirmatn:wght@200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Vazirmatn Persian Font */

/* ------------------------------
    THEME VARIABLES
--------------------------------*/
:root {
  --bg-gradient: linear-gradient(135deg, #f3f4f7, #e9ebee);
  --card-bg: rgba(255, 255, 255, 0.65);
  --card-border: rgba(0, 0, 0, 0.15);
  --text-color: #1d1d1f;
  --label-color: #3a3a3c;

  --input-bg: rgba(255, 255, 255, 0.8);
  --input-border: rgba(0, 0, 0, 0.3);

  --input-focus-border: #3478f6;
  --input-focus-bg: rgba(255, 255, 255, 1);

  --footer-opacity: 0.6;

  --shadow: 0px 10px 40px rgba(0, 0, 0, 0.12);
}

/* ---------- DARK MODE ---------- */
[data-theme="dark"] {
  --bg-gradient: linear-gradient(135deg, #080808, #1a1a1a);
  --card-bg: rgba(255, 255, 255, 0.08);
  --card-border: rgba(255, 255, 255, 0.15);
  --text-color: #ffffff;
  --label-color: #e5e5e7;

  --input-bg: rgba(255, 255, 255, 0.07);
  --input-border: rgba(255, 255, 255, 0.18);

  --input-focus-border: #5a8bff;
  --input-focus-bg: rgba(255, 255, 255, 0.12);

  --shadow: 0px 10px 35px rgba(0, 0, 0, 0.65);
}

/* Smooth Theme Transition */
* {
  transition: background-color 0.25s ease,
              color 0.25s ease,
              border-color 0.25s ease,
              -webkit-backdrop-filter 0.25s ease;
  transition: background-color 0.25s ease,
              color 0.25s ease,
              border-color 0.25s ease,
              backdrop-filter 0.25s ease;
  transition: background-color 0.25s ease,
              color 0.25s ease,
              border-color 0.25s ease,
              backdrop-filter 0.25s ease,
              -webkit-backdrop-filter 0.25s ease;
}

/* Apply Vazirmatn to entire project */
body {
  font-family: "Vazirmatn", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
  background: linear-gradient(135deg, #f3f4f7, #e9ebee);
  background: var(--bg-gradient);
  font-size: 20px;
  margin: 0;
}

input{
  font-family: "Vazirmatn", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
}


/* ------------------------------
    PAGE CONTAINER
--------------------------------*/
.prejoin-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #f3f4f7, #e9ebee);
  background: var(--bg-gradient);
  padding: 20px;
}

/* ------------------------------
    CARD DESIGN
--------------------------------*/
.prejoin-card {
  width: 430px;
  padding: 45px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.65);
  background: var(--card-bg);
  -webkit-backdrop-filter: blur(18px) saturate(180%);
          backdrop-filter: blur(18px) saturate(180%);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border: 1px solid var(--card-border);
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.12);
  box-shadow: var(--shadow);
  text-align: center;
  position: relative;
}

/* THEME TOGGLE BUTTON */
.theme-toggle {
  position: absolute;
  top: 18px;
  right: 18px;
  padding: 8px 10px;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border: 1px solid var(--card-border);
  border-radius: 8px;
  cursor: pointer;
  color: #1d1d1f;
  color: var(--text-color);
  font-size: 18px;
}

/* ------------------------------
    TITLE & SUBTITLE
--------------------------------*/
.title {
  font-size: 30px;
  font-weight: 900;
  margin-bottom: 10px;
  color: #1d1d1f;
  color: var(--text-color);
}

.subtitle {
  font-size: 15px;
  opacity: 0.8;
  margin-bottom: 30px;
  color: #1d1d1f;
  color: var(--text-color);
}

/* ------------------------------
    INPUT CONTAINER
--------------------------------*/
.new-entry {
  display: grid;
  grid-gap: 20px;
  gap: 20px;
}

.label {
  direction: rtl;
  text-align: right;
  font-size: 14px;
  font-weight: 600;
  color: #3a3a3c;
  color: var(--label-color);
}

.new-entry input {
  width: 100%;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border: 1px solid var(--input-border);
  background: rgba(255, 255, 255, 0.8);
  background: var(--input-bg);
  color: #1d1d1f;
  color: var(--text-color);
  font-size: 16px;
  direction: rtl;
  text-align: right;
}

.new-entry input:focus {
  border-color: #3478f6;
  border-color: var(--input-focus-border);
  background: rgba(255, 255, 255, 1);
  background: var(--input-focus-bg);
  box-shadow: 0px 0px 8px rgba(80, 130, 255, 0.3);
}

/* ------------------------------
    CONTROLS
--------------------------------*/
.new-controls {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* ------------------------------
    FOOTER
--------------------------------*/
.footer {
  margin-top: 35px;
  font-size: 14px;
  opacity: 0.6;
  opacity: var(--footer-opacity);
  color: #1d1d1f;
  color: var(--text-color);
}

/* ------------------------------------------
    ROOM PAGE NEW MODERN UI
------------------------------------------- */

.room-wrapper {
  direction: rtl;
  text-align: right;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f3f4f7, #e9ebee);
  background: var(--bg-gradient);
  color: #1d1d1f;
  color: var(--text-color);
}

/* ---------- TOP BAR ---------- */

.room-topbar {
  height: 70px;
  padding: 0 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  background: rgba(255, 255, 255, 0.65);

  background: var(--card-bg);
  -webkit-backdrop-filter: blur(18px);
          backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  border-bottom: 1px solid var(--card-border);
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.15);
}

.room-title {
  font-size: 22px;
  font-weight: 700;
}

.room-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.participant-counter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;

  background: rgba(255, 255, 255, 0.8);

  background: var(--input-bg);
  border: 1px solid rgba(0, 0, 0, 0.3);
  border: 1px solid var(--input-border);
  border-radius: 10px;
  font-size: 16px;
}

.leave-button {
  padding: 10px 18px;
  border-radius: 12px;
  border: none;

  background: #ff4c4c;
  color: white;
  font-size: 15px;
  cursor: pointer;
  transition: 0.2s ease;
}

.leave-button:hover {
  background: #ff3232;
}

/* ---------- LIVEKIT STAGE AREA ---------- */

.room-stage {
  flex: 1 1;
  overflow: hidden;
  padding: 10px;
}

.errorBox {
  padding: 30px;
  margin: 40px auto;
  text-align: center;
  background: rgba(255, 255, 255, 0.65);
  background: var(--card-bg);
  border-radius: 14px;
  width: 300px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border: 1px solid var(--card-border);
  color: #1d1d1f;
  color: var(--text-color);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAGlC;;iCAEiC;AACjC;EACE,wDAAwD;EACxD,oCAAoC;EACpC,kCAAkC;EAClC,qBAAqB;EACrB,sBAAsB;;EAEtB,oCAAoC;EACpC,kCAAkC;;EAElC,6BAA6B;EAC7B,wCAAwC;;EAExC,qBAAqB;;EAErB,2CAA2C;AAC7C;;AAEA,oCAAoC;AACpC;EACE,wDAAwD;EACxD,oCAAoC;EACpC,wCAAwC;EACxC,qBAAqB;EACrB,sBAAsB;;EAEtB,qCAAqC;EACrC,yCAAyC;;EAEzC,6BAA6B;EAC7B,2CAA2C;;EAE3C,2CAA2C;AAC7C;;AAEA,4BAA4B;AAC5B;EACE;;;gDAGsC;EAHtC;;;wCAGsC;EAHtC;;;;gDAGsC;AACxC;;AAEA,sCAAsC;AACtC;EACE;;gCAE8B;EAC9B,qDAA8B;EAA9B,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE;;gCAE8B;AAChC;;;AAGA;;iCAEiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qDAA8B;EAA9B,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;iCAEiC;AACjC;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qCAA0B;EAA1B,0BAA0B;EAC1B,kDAA0C;UAA1C,0CAA0C;EAC1C,qCAAoC;EAApC,oCAAoC;EACpC,6CAAyB;EAAzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,qCAAoC;EAApC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;iCAEiC;AACjC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;;iCAEiC;AACjC;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,oCAAqC;EAArC,qCAAqC;EACrC,oCAA2B;EAA3B,2BAA2B;EAC3B,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAuC;EAAvC,uCAAuC;EACvC,kCAAiC;EAAjC,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;;iCAEiC;AACjC;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;iCAEiC;AACjC;EACE,gBAAgB;EAChB,eAAe;EACf,YAA8B;EAA9B,8BAA8B;EAC9B,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;;6CAE6C;;AAE7C;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qDAA8B;EAA9B,8BAA8B;EAC9B,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA,kCAAkC;;AAElC;EACE,YAAY;EACZ,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,qCAA0B;;EAA1B,0BAA0B;EAC1B,mCAA2B;UAA3B,2BAA2B;EAC3B,4CAA2C;EAA3C,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;;EAEjB,oCAA2B;;EAA3B,2BAA2B;EAC3B,oCAAqC;EAArC,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;;EAEZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;;AAE7C;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qCAA0B;EAA1B,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,qCAAoC;EAApC,oCAAoC;EACpC,cAAwB;EAAxB,wBAAwB;AAC1B","sourcesContent":["/* Import Vazirmatn Persian Font */\n@import url(\"https://fonts.googleapis.com/css2?family=Vazirmatn:wght@200;300;400;500;600;700;800;900&display=swap\");\n\n/* ------------------------------\n    THEME VARIABLES\n--------------------------------*/\n:root {\n  --bg-gradient: linear-gradient(135deg, #f3f4f7, #e9ebee);\n  --card-bg: rgba(255, 255, 255, 0.65);\n  --card-border: rgba(0, 0, 0, 0.15);\n  --text-color: #1d1d1f;\n  --label-color: #3a3a3c;\n\n  --input-bg: rgba(255, 255, 255, 0.8);\n  --input-border: rgba(0, 0, 0, 0.3);\n\n  --input-focus-border: #3478f6;\n  --input-focus-bg: rgba(255, 255, 255, 1);\n\n  --footer-opacity: 0.6;\n\n  --shadow: 0px 10px 40px rgba(0, 0, 0, 0.12);\n}\n\n/* ---------- DARK MODE ---------- */\n[data-theme=\"dark\"] {\n  --bg-gradient: linear-gradient(135deg, #080808, #1a1a1a);\n  --card-bg: rgba(255, 255, 255, 0.08);\n  --card-border: rgba(255, 255, 255, 0.15);\n  --text-color: #ffffff;\n  --label-color: #e5e5e7;\n\n  --input-bg: rgba(255, 255, 255, 0.07);\n  --input-border: rgba(255, 255, 255, 0.18);\n\n  --input-focus-border: #5a8bff;\n  --input-focus-bg: rgba(255, 255, 255, 0.12);\n\n  --shadow: 0px 10px 35px rgba(0, 0, 0, 0.65);\n}\n\n/* Smooth Theme Transition */\n* {\n  transition: background-color 0.25s ease,\n              color 0.25s ease,\n              border-color 0.25s ease,\n              backdrop-filter 0.25s ease;\n}\n\n/* Apply Vazirmatn to entire project */\nbody {\n  font-family: \"Vazirmatn\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n  background: var(--bg-gradient);\n  font-size: 20px;\n  margin: 0;\n}\n\ninput{\n  font-family: \"Vazirmatn\", -apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\",\n    \"Helvetica Neue\", sans-serif;\n}\n\n\n/* ------------------------------\n    PAGE CONTAINER\n--------------------------------*/\n.prejoin-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: var(--bg-gradient);\n  padding: 20px;\n}\n\n/* ------------------------------\n    CARD DESIGN\n--------------------------------*/\n.prejoin-card {\n  width: 430px;\n  padding: 45px;\n  border-radius: 22px;\n  background: var(--card-bg);\n  backdrop-filter: blur(18px) saturate(180%);\n  border: 1px solid var(--card-border);\n  box-shadow: var(--shadow);\n  text-align: center;\n  position: relative;\n}\n\n/* THEME TOGGLE BUTTON */\n.theme-toggle {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  padding: 8px 10px;\n  background: transparent;\n  border: 1px solid var(--card-border);\n  border-radius: 8px;\n  cursor: pointer;\n  color: var(--text-color);\n  font-size: 18px;\n}\n\n/* ------------------------------\n    TITLE & SUBTITLE\n--------------------------------*/\n.title {\n  font-size: 30px;\n  font-weight: 900;\n  margin-bottom: 10px;\n  color: var(--text-color);\n}\n\n.subtitle {\n  font-size: 15px;\n  opacity: 0.8;\n  margin-bottom: 30px;\n  color: var(--text-color);\n}\n\n/* ------------------------------\n    INPUT CONTAINER\n--------------------------------*/\n.new-entry {\n  display: grid;\n  gap: 20px;\n}\n\n.label {\n  direction: rtl;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--label-color);\n}\n\n.new-entry input {\n  width: 100%;\n  padding: 14px;\n  border-radius: 10px;\n  border: 1px solid var(--input-border);\n  background: var(--input-bg);\n  color: var(--text-color);\n  font-size: 16px;\n  direction: rtl;\n  text-align: right;\n}\n\n.new-entry input:focus {\n  border-color: var(--input-focus-border);\n  background: var(--input-focus-bg);\n  box-shadow: 0px 0px 8px rgba(80, 130, 255, 0.3);\n}\n\n/* ------------------------------\n    CONTROLS\n--------------------------------*/\n.new-controls {\n  margin-top: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* ------------------------------\n    FOOTER\n--------------------------------*/\n.footer {\n  margin-top: 35px;\n  font-size: 14px;\n  opacity: var(--footer-opacity);\n  color: var(--text-color);\n}\n\n/* ------------------------------------------\n    ROOM PAGE NEW MODERN UI\n------------------------------------------- */\n\n.room-wrapper {\n  direction: rtl;\n  text-align: right;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-gradient);\n  color: var(--text-color);\n}\n\n/* ---------- TOP BAR ---------- */\n\n.room-topbar {\n  height: 70px;\n  padding: 0 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  background: var(--card-bg);\n  backdrop-filter: blur(18px);\n  border-bottom: 1px solid var(--card-border);\n  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.15);\n}\n\n.room-title {\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.room-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.participant-counter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: 10px;\n  font-size: 16px;\n}\n\n.leave-button {\n  padding: 10px 18px;\n  border-radius: 12px;\n  border: none;\n\n  background: #ff4c4c;\n  color: white;\n  font-size: 15px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.leave-button:hover {\n  background: #ff3232;\n}\n\n/* ---------- LIVEKIT STAGE AREA ---------- */\n\n.room-stage {\n  flex: 1;\n  overflow: hidden;\n  padding: 10px;\n}\n\n.errorBox {\n  padding: 30px;\n  margin: 40px auto;\n  text-align: center;\n  background: var(--card-bg);\n  border-radius: 14px;\n  width: 300px;\n  border: 1px solid var(--card-border);\n  color: var(--text-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
